export enum QuotationState {
  DRAFT = 'Draft',
  PENDING_CUSTOMER_APPROVAL = 'PendingCustomerApproval',
  PENDING_CUSTOMER_VALIDATION = 'PendingCustomerValidation',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  CANCELLED = 'Cancelled',
  PAID = 'Paid',
  END_OF_MONTH_CONSOLIDATED_PAYMENT = 'EndOfMonthConsolidatedPayment',
}

export enum QUOTATION_STATE_BY_KEY {
  Draft = 'Draft',
  PendingCustomerValidation = 'PendingCustomerValidation',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Cancelled = 'Cancelled',
  Paid = 'Paid',
  EndOfMonthConsolidatedPayment = 'EndOfMonthConsolidatedPayment',
}

export enum QuotationTypes {
  Internal = 'Internal',
  Subcontractor = 'Subcontractor',
}
